
<!-- TEMPLATE -->
<template>
    <fade-transition>
        <div :class='partnerOverviewClass'>
            <div class='row'>
                <div class='small-12 medium-12 large-12 hd-12 columns dashboard-content'>
                    <dean-section-title content='true'>
                        <span slot='title'>
                            <span class='avenir-heavy'>Partners</span>
                        </span>
                        <dean-section-title-item
                                v-if="canCreatePartner()"
                                :icon='plusIcon'
                                :content="true"
                                @click.native="sectionRoute('partners.add')"
                        >
                            Partner Toevoegen
                        </dean-section-title-item>
                    </dean-section-title>
                    <div class="filter">
                        <dean-form-row
                                @input="update(true)"
                                v-model="pageMeta.query"
                                class="top-bar"
                                hide-label="true"
                        >zoek
                        </dean-form-row>
                        <button :class="{active: type.indexOf('CP') > -1 }" id="commercialpartner">
                            <dean-icon
                                    :glyph="commercialPartnerIcon"
                                    @click.native="toggleType('CP'); update()"
                                    width="20"
                                    height="20"
                            ></dean-icon>
                        </button>
                        <b-tooltip target="commercialpartner" placement="bottom">
                            commercial
                        </b-tooltip>
                        <button :class="{active: type.indexOf('SP') > -1}" id="servicepartner">
                            <dean-icon
                                    :glyph="servicePartnerIcon"
                                    @click.native="toggleType('SP'); update()"
                                    width="20"
                                    height="20"
                            ></dean-icon>
                        </button>
                        <b-tooltip target="servicepartner" placement="bottom">
                            service
                        </b-tooltip>
                        <button :class="{active: type.indexOf('GO') > -1}" id="gopartner">
                            <dean-icon
                                    :glyph="goPartnerIcon"
                                    @click.native="toggleType('GO'); update()"
                                    width="20"
                                    height="20"
                            ></dean-icon>
                        </button>
                        <b-tooltip target="gopartner" placement="bottom">
                            Wholesale
                        </b-tooltip>
                    </div>
                    <dean-table
                            :data='partnerData'
                            :columns='columns'
                            @column-click='columnClick'
                            :hover="true"
                            @cell-click="cellClick"
                    >
                    </dean-table>
                    <dean-pagination
                            :current-page='partnerMetaData.pageNumber'
                            :total-items='partnerMetaData.totalResults'
                            :items-per-page='partnerMetaData.itemsPerPage'
                            :select-items-per-page='selectItemsPerPage'
                            :visible-pages='partnerMetaData.visiblePages'
                            @page-changed='paginationChanged'
                            @items-per-page='itemsPerPageChanged'
                    >
                    </dean-pagination>
                </div>
            </div>
        </div>
    </fade-transition>
</template>

<!-- SCRIPT -->

<script lang='ts'>
  // VUE
  import {
    Vue,
    Component,
  } from 'vue-property-decorator';
  import deanTableMixin from '@/mixins/deanTableMixin';
  import {mixins} from 'vue-class-component';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import commercialPartnerIcon from '@/assets/svg/partner-commercial.svg';
  import servicePartnerIcon from '@/assets/svg/partner-service.svg';
  import goPartnerIcon from '@/assets/svg/partner-go.svg';
  import {BTooltip} from 'bootstrap-vue';
  import {FadeTransition} from 'vue2-transitions';

  import {
    // SVG
    globeIcon,
    invoicesIcon,
    // COMPONENTS
    deanTable,
    deanPagination,
    deanInputSelect,
    deanSectionDivider,
    deanSectionTitle,
    deanSectionTitleItem,
    deanSearchField,
    deanIcon,
    plusIcon,
    summeryIcon,
    lockIcon,
    archiveIcon,
    partnerIcon,
  } from '@deanone/dean-components';

  @Component({
    components: {
      deanPagination,
      deanTable,
      deanInputSelect,
      deanSectionDivider,
      deanSectionTitle,
      deanSectionTitleItem,
      deanSearchField,
      invoicesIcon,
      deanIcon,
      plusIcon,
      summeryIcon,
      lockIcon,
      archiveIcon,
      FadeTransition,
      deanFormRow,
      BTooltip,
    },
  })
  export default class List extends mixins(deanTableMixin) {

    public showSomething: boolean = false;
    public data: any = [];
    public plusIcon: object = plusIcon;
    public queryTimeout!: number;
    public type: any = [];
    public commercialPartnerIcon: object = commercialPartnerIcon;
    public servicePartnerIcon: object = servicePartnerIcon;
    public goPartnerIcon: object = goPartnerIcon;

    // COMPUTED
    get partnerOverviewClass() {
      let value = 'partner-summary';
      if (this.showSomething) {
        value += ' no-scroll-container';
      }
      return value;
    }

    get partnerMetaData() {
      return this.pageMeta;
    }

    get partnerData() {
      return this.data;
    }

    // DATA
    public sideMenu: object = {
      content: {
        title: {
          text: 'Partners',
          mobile: {
            close: {
              text: 'Close',
              icon: invoicesIcon,
            },
          },
        },
        type: 'themed',
        sections: {
          general: {
            title: 'status',
            items: {
              summery: {
                title: 'Overzicht',
                icon: summeryIcon,
                name: 'partners.overview',
              },
              blocked: {
                title: 'Geblokkeerd',
                icon: lockIcon,
                name: 'partners.overview.status',
                params: {status: 'SUSPENDED'},
              },
              archived: {
                title: 'Archief',
                icon: archiveIcon,
                name: 'partners.overview.status',
                params: {status: 'DELETED'},
              },
            },
          },
        },
      },
    };

    public columns: any = {
      partnerCode: {
        content: 'Partnercode',
        align: 'left',
        sort: true,
        dql: 'code',
      },
      partnerName: {
        content: 'Partnernaam',
        align: 'left',
        sort: true,
        dql: 'name',
      },
      telephone: {
        content: 'Telefoon',
        align: 'left',
        sort: true,
        dql: 'phoneNumber',
      },
      customers: {
        content: 'Aantal klanten',
        align: 'left',
        sort: true,
        dql: 'customerCount',
      },
      agreements: {
        content: 'Aantal overeenkomsten',
        align: 'left',
        sort: false,
        dql: 'agreementCount',
      },
      postalCode: {
        content: 'Postcode',
        align: 'left',
        sort: true,
        dql: 'postalCode',
      },
      houseNumber: {
        content: 'Huisnummer',
        align: 'left',
        sort: true,
        dql: 'houseNumber',
      },
      city: {
        content: 'Plaats',
        align: 'left',
        sort: true,
        dql: 'city',
      },
    };

    public tableName(): string {
      return 'partners';
    }

    public update(timeout: boolean) {
      this.pageMeta.pageNumber = 1;

      const meta: any = this.pageMeta;

      const self = this;

      if (timeout) {
        if (this.queryTimeout) {
          clearTimeout(this.queryTimeout);
        }
        this.queryTimeout = setTimeout(() => {
          self.loadList(meta);
        }, 400);

      } else {
        this.loadList(meta);
      }
    }

    public toggleType(type: string) {
      const index = this.type.indexOf(type);
      if (index > -1) {
        this.type.splice(index, 1);
      } else {
        this.type.push(type);
      }
    }

    // METHODS
    public loadList(meta: any) {
      const type = this.$route.params.type ? this.$route.params.type : this.type.toString();
      meta.pageNumber = meta.pageNumber ? meta.pageNumber : 1;
      meta.startIndex = this.startIndex;
      meta.numberOfItems = meta.itemsPerPage;

      this.$store.dispatch('setLoadOverlay', true);
      this.axios.post('/-/trade/api/partners.list', {
        meta,
        filter: meta.query,
        sort: meta.sort,
        status: this.$route.params.status,
        type,
      }).then(
        (response) => {
          this.data = [];

          for (const partner of response.data.data) {
            const row: any = {};

            row.id = partner.id;
            row.partnerCode = partner.code;
            row.partnerName = partner.name;
            row.telephone = partner.phoneNumber;
            row.customers = partner.customerCount;
            row.agreements = partner.agreementCount;

            if (partner.address) {
              row.postalCode = partner.address.postalCode;
              row.houseNumber = partner.address.houseNumber + (
                  partner.address.houseNumberExtension ?
                      '-' + partner.address.houseNumberExtension :
                      ''
              );
              row.city = partner.address.city;
            } else {
              row.postalCode =
                row.houseNumber =
                  row.city = null;
            }

            this.data.push(row);
          }

          this.updateMeta(response.data.meta);

          this.$store.dispatch('setLoadOverlay', false);

          this.$store.dispatch('updateSideMenu', this.sideMenu);
        },
        (error) => {
            this.$toast(this.$store.state.main.notification.messages.couldNotReceiveData);
            this.$store.dispatch('setLoadOverlay', false);
        },
      );
    }

    public cellClick(target: { cell: object, row: { id: string, partnerAgreementId: string }, column: string }) {
      this.$router.push({
        name: 'partners.edit',
        params: {pid: target.row.id},
      });
    }

    public canCreatePartner(): boolean {
      if (this.$store.getters.getUser.privileges.includes('create-partner')) {
        return true;
      }

      return false;
    }

    public created() {
      this.keepMetaSavedInState();
      this.setDefaultSort('name');
      this.loadList(this.pageMeta);
    }
  }
</script>

<!-- STYLE -->

<style lang='scss' scoped>
    @import '~@deanone/dean-components/src/scss/vars';

    .filter {
        display: flex;
    }

    button {
        fill: var(--color-dark, $color-dark);
        background: none;
        padding: 5px;
        border: 0;
        margin: 5px;
        transition: fill .3s;
        border-radius: 5px;
    }

    button.active,
    button:hover {
        fill: var(--color-secondary, $color-secondary);
    }

    .top-bar {
        display: inline-block;
    }

    :deep(.top-bar .hd-6.columns) {
      width: 100%;
    }
</style>
